import { render, staticRenderFns } from "./SelectAdditionalServicesComponent.vue?vue&type=template&id=62a5acea&scoped=true"
import script from "./SelectAdditionalServicesComponent.vue?vue&type=script&lang=js"
export * from "./SelectAdditionalServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectAdditionalServicesComponent.vue?vue&type=style&index=0&id=62a5acea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a5acea",
  null
  
)

export default component.exports